function getWishlist() {
  try {
    return JSON.parse(localStorage.getItem('wishlist') || '[]');
  } catch (e) {
    return [];
  }
}

function saveWishlist(wishlist) {
  localStorage.setItem('wishlist', JSON.stringify(wishlist));
}

function escapeHtml(value = '') {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function updateWishlistButtons() {
  const wishlist = getWishlist();

  document.querySelectorAll('.wishlist-button').forEach(btn => {
    const exists = wishlist.some(
      item => String(item.id) === String(btn.dataset.productId)
    );


const icon = btn.querySelector('.wishlist-icon');

btn.classList.toggle('is-active', exists);

if (icon) {
  icon.textContent = exists ? '♥' : '♡';
}


  });
}


/* =========================
   찜 버튼
========================= */

document.addEventListener('click', function(e) {
  const btn = e.target.closest('.wishlist-button');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

let colorGroup = [];

try {
  colorGroup = JSON.parse(btn.dataset.colorGroup || '[]');
} catch (error) {
  console.error('Wishlist color group parse error:', error);
}

const product = {
  id: String(btn.dataset.productId),
  handle: btn.dataset.productHandle,
  title: btn.dataset.productTitle,
  url: btn.dataset.productUrl,
  colorGroup: colorGroup,
  colorName: btn.dataset.colorName || ''
};

  let wishlist = getWishlist();

  const exists = wishlist.some(
    item => String(item.id) === product.id
  );

  if (exists) {
    wishlist = wishlist.filter(
      item => String(item.id) !== product.id
    );
  } else {
    wishlist.push(product);
  }

  saveWishlist(wishlist);
  updateWishlistButtons();
});


/* =========================
   위시리스트 상품 렌더링
========================= */

async function renderWishlistPage() {
  const container = document.getElementById('wishlist-products');
  const emptyMessage = document.getElementById('wishlist-empty');

  if (!container) return;

  const wishlist = getWishlist();

  if (!wishlist.length) {
    container.innerHTML = '';
    if (emptyMessage) emptyMessage.style.display = 'block';
    return;
  }

  if (emptyMessage) emptyMessage.style.display = 'none';

  const products = await Promise.all(
    wishlist.map(async item => {
      try {
        const response = await fetch(`/products/${item.handle}.js`);
        if (!response.ok) return null;

        const product = await response.json();

return {
  ...product,
  wishlistId: String(item.id),
  colorGroup: Array.isArray(item.colorGroup) ? item.colorGroup : [],
  colorName: item.colorName || ''
};
      } catch (error) {
        console.error('Wishlist product load error:', error);
        return null;
      }
    })
  );

  container.innerHTML = '';

  products.filter(Boolean).forEach(product => {
    const price = new Intl.NumberFormat('ko-KR').format(
      product.price / 100
    );

    const card = document.createElement('div');

    card.className = 'wishlist-page__item';
    card.dataset.productId = product.wishlistId;

    /* 나중에 모달에서 사용할 상품 데이터 */
    card._wishlistProduct = product;

    card.innerHTML = `
      <div class="wishlist-page__image-wrap">

        <label class="wishlist-page__check">
          <input
            type="checkbox"
            class="wishlist-item-checkbox"
            data-product-id="${product.wishlistId}"
          >
        </label>

        <button
          type="button"
          class="wishlist-page__remove"
          data-product-id="${product.wishlistId}"
          aria-label="위시리스트에서 삭제"
        >
          ×
        </button>

        <a href="${product.url}" class="wishlist-page__image">
          <img
            src="${product.featured_image || ''}"
            alt="${escapeHtml(product.title)}"
            loading="lazy"
          >
        </a>

      </div>

<div class="wishlist-page__info">

  <a href="${product.url}" class="wishlist-page__title">
    ${escapeHtml(product.title)}
  </a>

  <div class="wishlist-page__price">
    ₩${price}
  </div>

  <button
    type="button"
    class="wishlist-page__mobile-remove wishlist-page__remove"
    data-product-id="${product.wishlistId}"
    aria-label="위시리스트에서 삭제"
  >
    삭제
  </button>

</div>
    `;

    container.appendChild(card);
  });
}


/* =========================
   전체 선택
========================= */

document.addEventListener('click', function(e) {
  if (e.target.id !== 'wishlist-select-all') return;

  document
    .querySelectorAll('.wishlist-item-checkbox')
    .forEach(input => {
      input.checked = e.target.checked;
    });
});


function getSelectedCards() {
  return [
    ...document.querySelectorAll(
      '.wishlist-item-checkbox:checked'
    )
  ]
    .map(input => input.closest('.wishlist-page__item'))
    .filter(Boolean);
}


/* =========================
   개별 삭제
========================= */

document.addEventListener('click', function(e) {
  const removeBtn = e.target.closest('.wishlist-page__remove');
  if (!removeBtn) return;

  const productId = String(removeBtn.dataset.productId);

  let wishlist = getWishlist();

  wishlist = wishlist.filter(
    item => String(item.id) !== productId
  );

  saveWishlist(wishlist);

  const card = removeBtn.closest('.wishlist-page__item');
  if (card) card.remove();

  updateWishlistButtons();
  updateEmptyState();
});


/* =========================
   선택 상품 삭제
========================= */

document.addEventListener('click', function(e) {
  if (e.target.id !== 'wishlist-delete-selected') return;

  const cards = getSelectedCards();

  if (!cards.length) {
    alert('삭제할 상품을 선택해주세요.');
    return;
  }

  const ids = cards.map(card => String(card.dataset.productId));

  let wishlist = getWishlist();

  wishlist = wishlist.filter(
    item => !ids.includes(String(item.id))
  );

  saveWishlist(wishlist);

  cards.forEach(card => card.remove());

  updateWishlistButtons();
  updateEmptyState();
});


function updateEmptyState() {
  const container = document.getElementById('wishlist-products');
  const emptyMessage = document.getElementById('wishlist-empty');
  const selectAll = document.getElementById('wishlist-select-all');

  if (!container) return;

  const hasProducts =
    container.querySelectorAll('.wishlist-page__item').length > 0;

  if (emptyMessage) {
    emptyMessage.style.display = hasProducts ? 'none' : 'block';
  }

  if (selectAll && !hasProducts) {
    selectAll.checked = false;
  }
}


/* =========================
   옵션이 실제로 있는지 확인
========================= */

function getRealOptions(product) {
  const options = Array.isArray(product.options)
    ? product.options
    : [];

  return options
    .map((option, index) => {
      const name =
        typeof option === 'string'
          ? option
          : option.name || `옵션 ${index + 1}`;

      const values = [
        ...new Set(
          product.variants
            .map(variant => {
              if (Array.isArray(variant.options)) {
                return variant.options[index];
              }

              return variant[`option${index + 1}`];
            })
            .filter(Boolean)
        )
      ];

      return {
        name,
        index,
        values
      };
    })
    .filter(option => {
      return !(
        option.name === 'Title' &&
        option.values.length <= 1
      );
    });
}


/* =========================
   장바구니 클릭
========================= */

document.addEventListener('click', function(e) {
  if (e.target.id !== 'wishlist-add-selected-cart') return;

  const cards = getSelectedCards();

  if (!cards.length) {
    alert('장바구니에 담을 상품을 선택해주세요.');
    return;
  }

  openWishlistOptionModal(cards);
});


/* =========================
   옵션 모달 생성
========================= */
function buildWishlistVariantOptions(product, cardIndex) {
  const options = getRealOptions(product);

  if (!options.length) {
    return `
      <div class="wishlist-modal__no-option">
        옵션 선택이 필요하지 않은 상품입니다.
      </div>
    `;
  }

  let html = '';

  options.forEach((option, optionOrder) => {
    let availableValues = option.values;

    /* 첫 옵션 이후는 앞에서 선택된 값에 따라 나중에 필터링 */
    if (optionOrder > 0) {
      availableValues = option.values;
    }

    html += `
      <div
        class="wishlist-modal__option"
        data-option-order="${optionOrder}"
      >
        <div class="wishlist-modal__option-name">
          ${escapeHtml(option.name)}
        </div>

        <select
          class="wishlist-modal__select"
          data-card-index="${cardIndex}"
          data-option-index="${option.index}"
          data-option-order="${optionOrder}"
        >
          <option value="">선택해주세요</option>

          ${availableValues.map(value => `
            <option value="${escapeHtml(value)}">
              ${escapeHtml(value)}
            </option>
          `).join('')}
        </select>
      </div>
    `;
  });

  return html;
}
function openWishlistOptionModal(cards) {
  document
    .querySelectorAll('.wishlist-option-modal')
    .forEach(modal => modal.remove());

  const modal = document.createElement('div');
  modal.className = 'wishlist-option-modal';

  let productsHtml = '';

  cards.forEach((card, cardIndex) => {
    const product = card._wishlistProduct;

    if (!product) return;

    const options = getRealOptions(product);
const colorGroup = Array.isArray(product.colorGroup)
  ? product.colorGroup
  : [];
const isOnePercent = product.title.includes('1%');
let colorGroupHtml = '';

if (colorGroup.length) {
  colorGroupHtml = `
    <div class="wishlist-modal__option">
      <div class="wishlist-modal__option-name">
        색상
      </div>

      <select
        class="wishlist-modal__select wishlist-modal__color-select"
        data-card-index="${cardIndex}"
      >
        <option value="">선택해주세요</option>

        ${colorGroup.map(item => `
          <option
            value="${escapeHtml(item.handle)}"
            ${item.handle === product.handle ? 'selected' : ''}
          >
            ${escapeHtml(item.colorName || item.title || '기본')}
          </option>
        `).join('')}
      </select>
    </div>
  `;
}
let optionHtml = buildWishlistVariantOptions(product, cardIndex);

    productsHtml += `
      <div
        class="wishlist-modal__product"
        data-card-index="${cardIndex}"
      >

        <div class="wishlist-modal__product-top">

          <img
            src="${product.featured_image || ''}"
            alt="${escapeHtml(product.title)}"
          >

          <div>
            <div class="wishlist-modal__product-title">
              ${escapeHtml(product.title)}
            </div>

            <div class="wishlist-modal__product-price">
              ₩${new Intl.NumberFormat('ko-KR').format(
                product.price / 100
              )}
            </div>
          </div>

        </div>
${colorGroupHtml}

<div class="wishlist-modal__variant-options">
  ${
    options.length
      ? optionHtml
      : colorGroup.length
        ? ''
        : `
          <div class="wishlist-modal__no-option">
            옵션 선택이 필요하지 않은 상품입니다.
          </div>
        `
  }
</div>
${
  isOnePercent
    ? `
      <div class="wishlist-inspection wishlist-inspection--notice">
        <div class="wishlist-inspection__notice-icon">!</div>

        <div class="wishlist-inspection__content">
          <div class="wishlist-inspection__top">
            <strong>1% 제품 안내</strong>
            <span>검수사진 제공 불가</span>
          </div>

          <p>
            자체 제작 상품으로 제작 과정에서 검수 완료되어
            별도 검수사진은 제공되지 않습니다.
          </p>
        </div>
      </div>
    `
    : `
      <label class="wishlist-inspection">
        <input
          type="checkbox"
          class="wishlist-inspection__checkbox"
          data-card-index="${cardIndex}"
        >

        <span class="wishlist-inspection__box"></span>

        <div class="wishlist-inspection__content">
          <strong>검수사진 요청</strong>
          <p>발송 전 제품 상태를 사진으로 안내해드립니다.</p>
        </div>
        <div class="wishlist-inspection__notice">
  <div class="wishlist-inspection__important">
    <span class="wishlist-inspection__important-label">필수</span>

    <span class="wishlist-inspection__important-text">
      검수사진 요청 후
      <b>고객센터 카카오톡으로 "검수사진 요청" 전달</b>
      부탁드립니다.
    </span>
  </div>

  <span class="wishlist-inspection__sub">
    미전달 시 검수사진 없이 발송됩니다.
  </span>
</div>
      </label>
    `
}
        <div
          class="wishlist-modal__error"
          style="display:none;"
        ></div>

      </div>
    `;
  });

  modal.innerHTML = `
    <div class="wishlist-modal__overlay"></div>

    <div class="wishlist-modal__box">

      <button
        type="button"
        class="wishlist-modal__close"
        aria-label="닫기"
      >
        ×
      </button>

      <div class="wishlist-modal__header">
        <h2>옵션 선택</h2>
        <p>장바구니에 담을 상품의 옵션을 선택해주세요.</p>
      </div>

      <div class="wishlist-modal__products">
        ${productsHtml}
      </div>

      <div class="wishlist-modal__footer">
        <button
          type="button"
          class="wishlist-modal__cancel"
        >
          취소
        </button>

        <button
          type="button"
          class="wishlist-modal__confirm"
        >
          장바구니에 담기
        </button>
      </div>

    </div>
  `;

  modal._wishlistCards = cards;

  document.body.appendChild(modal);
  document.body.classList.add('wishlist-modal-open');
}


/* =========================
   모달 닫기
========================= */

document.addEventListener('click', function(e) {
  if (
    e.target.closest('.wishlist-modal__close') ||
    e.target.closest('.wishlist-modal__cancel') ||
    e.target.classList.contains('wishlist-modal__overlay')
  ) {
    closeWishlistModal();
  }
});


function closeWishlistModal() {
  const modal = document.querySelector('.wishlist-option-modal');

  if (modal) modal.remove();

  document.body.classList.remove('wishlist-modal-open');
}
/* =========================
   검수사진 요청 필독 팝업
========================= */

document.addEventListener('change', function(e) {
  if (!e.target.classList.contains('wishlist-inspection__checkbox')) return;

  const checkbox = e.target;

  if (!checkbox.checked) return;

  const oldModal = document.querySelector('.wishlist-inspection-modal');
  if (oldModal) oldModal.remove();

  const inspectionModal = document.createElement('div');
  inspectionModal.className = 'wishlist-inspection-modal';

  inspectionModal.innerHTML = `
    <div class="wishlist-inspection-modal__dim"></div>

    <div class="wishlist-inspection-modal__box">
      <div class="wishlist-inspection-modal__text">

        <div class="wishlist-inspection-modal__title">
          검수사진 요청 고객님 필독 안내
        </div>

        <div class="wishlist-inspection-modal__block">
          ☑️ 검수사진 요청 시 출고가 <b>약 5~7일 정도 지연</b>될 수 있으며
          검수 중 재촬영 요청 시 <b>추가 시간 지연</b>이 발생할 수 있습니다.
          <span>
            (제품은 주문 순서대로 출고되며, 검수 확인 후에도 바로 출고되지 않을 수 있습니다.)
          </span>
        </div>

        <div class="wishlist-inspection-modal__block">
          ☑️ 검수사진 확인 후 제품 수령 시
          사진으로 확인 가능했던 부분에 대해서는
          <b>교환 및 환불이 절대 불가합니다.</b>
          <span>(배송 중 문제 제외)</span>
        </div>

        <div class="wishlist-inspection-modal__block">
          ☑️ 검수는 정품 기준으로 진행되며
          <span>
            (박음질, 마감, 가죽 개체, 유약, 패턴 등 차이 포함)
          </span>
          개인 기호 사유로는
          <b>교환 및 환불이 어렵습니다.</b>
        </div>

      </div>

      <div class="wishlist-inspection-modal__actions">
        <button type="button" class="wishlist-inspection-modal__cancel">취소</button>
        <button type="button" class="wishlist-inspection-modal__confirm">동의</button>
      </div>
    </div>
  `;

  document.body.appendChild(inspectionModal);

  inspectionModal
    .querySelector('.wishlist-inspection-modal__confirm')
    .addEventListener('click', function() {
      inspectionModal.remove();
    });

  inspectionModal
    .querySelector('.wishlist-inspection-modal__cancel')
    .addEventListener('click', function() {
      checkbox.checked = false;
      inspectionModal.remove();
    });

  inspectionModal
    .querySelector('.wishlist-inspection-modal__dim')
    .addEventListener('click', function() {
      checkbox.checked = false;
      inspectionModal.remove();
    });
});
document.addEventListener('change', async function(e) {
  if (!e.target.matches('.wishlist-modal__color-select')) return;

  const colorSelect = e.target;
  const productBox = colorSelect.closest('.wishlist-modal__product');

  if (!productBox) return;

  const cardIndex = colorSelect.dataset.cardIndex;
  const selectedHandle = colorSelect.value;

  const optionsWrap = productBox.querySelector(
    '.wishlist-modal__variant-options'
  );

  if (!optionsWrap) return;

  /* 기존 옵션 먼저 제거 */
  optionsWrap.innerHTML = '';

  if (!selectedHandle) return;

  try {
    const response = await fetch(
      `/products/${encodeURIComponent(selectedHandle)}.js`
    );

    if (!response.ok) {
      throw new Error('Selected color product load failed');
    }

    const selectedProduct = await response.json();

    const newOptions = getRealOptions(selectedProduct);

    if (!newOptions.length) {
      optionsWrap.innerHTML = '';
      return;
    }

    optionsWrap.innerHTML =
      buildWishlistVariantOptions(selectedProduct, cardIndex);

  } catch (error) {
    console.error('Wishlist color option refresh error:', error);
  }
});
document.addEventListener('change', function(e) {
  const changedSelect = e.target.closest('.wishlist-modal__select');

  if (!changedSelect) return;
  if (changedSelect.classList.contains('wishlist-modal__color-select')) return;

  const productBox = changedSelect.closest('.wishlist-modal__product');
  if (!productBox) return;

  const cardIndex = changedSelect.dataset.cardIndex;
  const card = document.querySelector(
    `.wishlist-page__card[data-card-index="${cardIndex}"]`
  );

  const modal = changedSelect.closest('.wishlist-option-modal');
  if (!modal) return;

  const cards = modal._wishlistCards || [];
  const originalProduct = cards[Number(cardIndex)]?._wishlistProduct;

  if (!originalProduct) return;

  const selects = Array.from(
    productBox.querySelectorAll(
      '.wishlist-modal__select:not(.wishlist-modal__color-select)'
    )
  );

  const currentOrder = Number(changedSelect.dataset.optionOrder);

  const selectedValues = {};

  selects.forEach(select => {
    const order = Number(select.dataset.optionOrder);

    if (order <= currentOrder && select.value) {
      selectedValues[Number(select.dataset.optionIndex)] = select.value;
    }
  });

  const options = getRealOptions(originalProduct);

  options.forEach((option, optionOrder) => {
    if (optionOrder <= currentOrder) return;

    const targetSelect = productBox.querySelector(
      `.wishlist-modal__select[data-option-order="${optionOrder}"]`
    );

    if (!targetSelect) return;

    const possibleValues = new Set();

    originalProduct.variants.forEach(variant => {
      const variantOptions = Array.isArray(variant.options)
        ? variant.options
        : [
            variant.option1,
            variant.option2,
            variant.option3
          ].filter(Boolean);

      const matchesPrevious = Object.entries(selectedValues).every(
        ([optionIndex, selectedValue]) =>
          String(variantOptions[Number(optionIndex)]) ===
          String(selectedValue)
      );

      if (!matchesPrevious) return;

      const value = variantOptions[option.index];

      if (value) {
        possibleValues.add(value);
      }
    });

    targetSelect.innerHTML = `
      <option value="">선택해주세요</option>

      ${Array.from(possibleValues).map(value => `
        <option value="${escapeHtml(value)}">
          ${escapeHtml(value)}
        </option>
      `).join('')}
    `;
  });
});
/* =========================
   선택된 옵션 → Variant 찾기
========================= */

function findSelectedVariant(product, productBox) {
  const options = getRealOptions(product);

  /* 옵션 없는 상품 */
  if (!options.length) {
    return (
      product.variants.find(variant => variant.available) ||
      null
    );
  }

  const selectedValues = [];

  for (const option of options) {
    const select = productBox.querySelector(
      `.wishlist-modal__select[data-option-index="${option.index}"]`
    );

    if (!select || !select.value) {
      return {
        error: '옵션을 모두 선택해주세요.'
      };
    }

    selectedValues[option.index] = select.value;
  }

  const variant = product.variants.find(variant => {
    const variantOptions = Array.isArray(variant.options)
      ? variant.options
      : [
          variant.option1,
          variant.option2,
          variant.option3
        ].filter(Boolean);

    return options.every(option => {
      return String(variantOptions[option.index]) ===
        String(selectedValues[option.index]);
    });
  });

  if (!variant) {
    return {
      error: '선택하신 옵션 조합이 없습니다.'
    };
  }

  if (!variant.available) {
    return {
      error: '현재 품절된 옵션입니다.'
    };
  }

  return variant;
}


/* =========================
   모달 → 장바구니 담기
========================= */

document.addEventListener('click', async function(e) {
  const confirmBtn = e.target.closest(
    '.wishlist-modal__confirm'
  );

  if (!confirmBtn) return;

  const modal = confirmBtn.closest('.wishlist-option-modal');

  if (!modal) return;

  const cards = modal._wishlistCards || [];

  const items = [];
  let hasError = false;

  for (let index = 0; index < cards.length; index++) {
  const card = cards[index];
  const product = card._wishlistProduct;

  const productBox = modal.querySelector(
    `.wishlist-modal__product[data-card-index="${index}"]`
  );

  if (!product || !productBox) continue;

  const errorBox = productBox.querySelector(
    '.wishlist-modal__error'
  );

  let selectedProduct = product;

  /* 메타필드 컬러 상품 선택 */
  if (Array.isArray(product.colorGroup) && product.colorGroup.length) {
    const colorSelect = productBox.querySelector(
      '.wishlist-modal__color-select'
    );

    if (!colorSelect || !colorSelect.value) {
      hasError = true;

      if (errorBox) {
        errorBox.textContent = '색상을 선택해주세요.';
        errorBox.style.display = 'block';
      }

      continue;
    }

    try {
      const colorResponse = await fetch(
        `/products/${encodeURIComponent(colorSelect.value)}.js`
      );

      if (!colorResponse.ok) {
        throw new Error('Color product load failed');
      }

      selectedProduct = await colorResponse.json();

    } catch (error) {
      console.error('Wishlist color product load error:', error);

      hasError = true;

      if (errorBox) {
        errorBox.textContent = '선택한 색상 정보를 불러오지 못했습니다.';
        errorBox.style.display = 'block';
      }

      continue;
    }
  }

  const result = findSelectedVariant(
    selectedProduct,
    productBox
  );

  if (!result || result.error) {
    hasError = true;

    if (errorBox) {
      errorBox.textContent =
        result?.error || '옵션을 확인해주세요.';

      errorBox.style.display = 'block';
    }

    continue;
  }

  if (errorBox) {
    errorBox.style.display = 'none';
  }

 const inspectionCheckbox = productBox.querySelector(
  '.wishlist-inspection__checkbox'
);

const cartItem = {
  id: Number(result.id),
  quantity: 1
};

if (inspectionCheckbox && inspectionCheckbox.checked) {
  cartItem.properties = {
    '검수사진': '★ 검수사진 요청'
  };
}

items.push(cartItem);
}

  if (hasError) return;

  if (!items.length) return;

  confirmBtn.disabled = true;
  confirmBtn.textContent = '담는 중...';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },

      body: JSON.stringify({
        items
      })
    });

    if (!response.ok) {
      throw new Error('Cart add failed');
    }

    /* 장바구니 성공 → 위시리스트에서 제거 */

    const ids = cards.map(
      card => String(card.dataset.productId)
    );

    let wishlist = getWishlist();

    wishlist = wishlist.filter(
      item => !ids.includes(String(item.id))
    );

    saveWishlist(wishlist);

    cards.forEach(card => card.remove());

    updateWishlistButtons();
    updateEmptyState();
    closeWishlistModal();

    /* 장바구니로 이동 */
    window.location.href = '/cart';

  } catch (error) {
    console.error(error);

    confirmBtn.disabled = false;
    confirmBtn.textContent = '장바구니에 담기';

    alert(
      '장바구니에 담는 중 문제가 발생했습니다. 다시 시도해주세요.'
    );
  }
});


/* =========================
   최초 실행
========================= */

document.addEventListener('DOMContentLoaded', function() {
  updateWishlistButtons();
  renderWishlistPage();
});